import OutletSelectionSFC from "./OutletSelection.vue";
export const OutletSelection = OutletSelectionSFC;
